import React from 'react'
import clsx from 'clsx'

import styles from './_.module.css'

interface Props {
  modalRemove: () => void
  showCommentsInput: (val: boolean) => void
  commentIcon: React.ReactElement
  contraIcon: React.ReactElement
  supportIcon: React.ReactElement
  neutralIcon: React.ReactElement
  refData: {
    score: number
    snippet: string
    title: string
    type: string
    url: string
  }[]
  setInputText: (val: string) => void
}

export const ReferenceItem: React.FC<Props> = ({
  showCommentsInput,
  commentIcon,
  contraIcon,
  supportIcon,
  neutralIcon,
  refData,
  setInputText,
  modalRemove
}) => {
  return (
    <div>
      {refData.length ? (
        <>
          <div className={styles.refFoundText}>
            We’ve found the following references for the above text
          </div>
        </>
      ) : null}
      {refData.map(data => (
        <div
          key={data.type}
          className={clsx(styles.cardBody, {
            [styles.cardBodySupportive]: data.type === 'supportive',
            [styles.cardBodyNeutral]: data.type === 'neutral',
            [styles.cardBodyContra]: data.type === 'contradictory'
          })}
        >
          <div>
            <a
              className={styles.linkText}
              href={data.url}
              target="_blank"
              rel="noreferrer"
            >
              {data.url}
            </a>
            <p>{data.snippet}</p>
          </div>
          <hr className={styles.separation} />
          <div className={styles.cardFooter}>
            <div
              role="none"
              className={styles.addComment}
              onClick={() => {
                showCommentsInput(true)
                setInputText(
                  `<p>${
                    data.type.charAt(0).toUpperCase() + data.type.slice(1)
                  } reference:</p>
                  <br>
                  <a href=${data.url} target="_blank">${data.url}</a>
                  <p>${data.snippet}</p>`
                )
                modalRemove()
              }}
            >
              <div className={styles.commentIcon}>{commentIcon}</div>
              <div className={styles.commentText}>Add as comment</div>
            </div>
            {data.type === 'supportive' && (
              <div className={styles.supportive}>
                <div className={styles.supportIcon}>{supportIcon}</div>
                <div className={styles.supportText}>Supportive Reference</div>
              </div>
            )}
            {data.type === 'neutral' && (
              <div className={styles.neutral}>
                <div className={styles.neutralIcon}>{neutralIcon}</div>
                <div className={styles.neutralText}>Neutral Reference</div>
              </div>
            )}
            {data.type === 'contradictory' && (
              <div className={styles.contradiction}>
                <div className={styles.contraIcon}>{contraIcon}</div>
                <div className={styles.contraText}>Contradictory Reference</div>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
